/**
 * External dependencies
 */
import { usePage } from '@inertiajs/react';

/**
 * Internal dependencies
 */
import LogoAlt from '@/assets/images/logo-alt.svg';
// import RegisterStays from '@/resources/js/Pages/HostMarketplace/Auth/RegisterStays';
import FormRegisterStays from '@/hosts-marketplace/blocks/forms/form-register-stays/form-register-stays';
import { useForm } from '@inertiajs/react';
import { router } from '@inertiajs/react';

const VerifyingContent = (error) => {
    const { data, setData, errors } = useForm([]);
    const { externalLinks } = usePage().props;

    const handleHandleSubmit = (formData) => {
        if (!formData.length) return;
        router.post(route('register.stays.store'), formData);
    };

    // Deconstruct error object into errorMessage, propertiesList, and sessionDetails
    // const { errorMessage, propertiesList, sessionDetails } = error.error;

    const errorMessage = error.error && error.error[0] ? error.error[0] : '';
    const propertiesList = error.error && error.error[1] ? error.error[1] : 'No properties found';
    const totalProperties = error?.props?.totalProperties;

    return (
        <>
            {Array.isArray(propertiesList) && propertiesList?.length == 0 && !!error?.props?.message ? (
                router.visit(route('register.stays'), { method: 'get' })
            ) : (
                <div className="form-guest form-guest--register">
                    <div className="form-guest__image">
                        <a href={externalLinks?.inhouse?.main}>
                            <img src={LogoAlt} alt="" />
                        </a>
                    </div>

                    <div className="form-guest__head">
                        <h1 className="h1 form-guest__title">Thanks for your submission!</h1>

                        <p className="color-dark-60 p1 form-guest_review-message">
                            Our team is reviewing your info, and we expect to verify you within{' '}
                            <span className="bold">24 hours</span>.
                        </p>

                        <div className="form-guest_thank-you_add-a-property">
                            <a href={route('register.stays')} className="color-dark-60 p1 form-guest_add-a-property">
                                <svg
                                    style={{ textDecoration: 'underline', marginRight: '6px' }}
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11.8125 6.25C11.8125 6.63281 11.5117 6.90625 11.1562 6.90625H6.78125V11.2812C6.78125 11.6641 6.48047 11.9648 6.125 11.9648C5.74219 11.9648 5.46875 11.6641 5.46875 11.2812V6.90625H1.09375C0.710938 6.90625 0.4375 6.63281 0.4375 6.27734C0.4375 5.89453 0.710938 5.59375 1.09375 5.59375H5.46875V1.21875C5.46875 0.863281 5.74219 0.589844 6.125 0.589844C6.48047 0.589844 6.78125 0.863281 6.78125 1.21875V5.59375H11.1562C11.5117 5.59375 11.8125 5.89453 11.8125 6.25Z"
                                        fill="#333132"
                                    />
                                </svg>
                                Add More Properties
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VerifyingContent;
